import React, { useEffect, useState } from 'react';
import { UsersIcon, SearchIcon, FilterIcon, ShieldIcon, XIcon } from 'lucide-react';
import { SuccessNotification } from '../shared/SuccessNotification';
interface UserFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  initialData?: any;
}
const UserFormModal: React.FC<UserFormModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  initialData
}) => {
  const [formData, setFormData] = useState(initialData || {
    name: '',
    username: '',
    email: '',
    role: 'User',
    unit: '',
    status: 'Aktif'
  });
  // Update form data when initialData changes
  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData({
        name: '',
        username: '',
        email: '',
        role: 'User',
        unit: '',
        status: 'Aktif'
      });
    }
  }, [initialData, isOpen]);
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-3270">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col" data-id="element-3271">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center bg-neutral-light" data-id="element-3272">
          <h2 className="text-xl font-bold text-secondary flex items-center" data-id="element-3273">
            <UsersIcon size={20} className="mr-2 text-primary" data-id="element-3274" />
            {initialData ? 'Edit Pengguna' : 'Tambah Pengguna Baru'}
          </h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-200 transition-colors" data-id="element-3275">
            <XIcon size={20} className="text-gray-500" data-id="element-3276" />
          </button>
        </div>
        <div className="overflow-y-auto p-6 flex-grow" data-id="element-3277">
          <form id="user-form" onSubmit={handleSubmit} className="space-y-4" data-id="element-3278">
            <div className="space-y-1" data-id="element-3279">
              <label className="text-sm font-medium text-gray-700" data-id="element-3280">
                Nama Lengkap <span className="text-red-500" data-id="element-3281">*</span>
              </label>
              <input type="text" required value={formData.name} onChange={e => setFormData({
              ...formData,
              name: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Nama lengkap pengguna" data-id="element-3282" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-3283">
              <div className="space-y-1" data-id="element-3284">
                <label className="text-sm font-medium text-gray-700" data-id="element-3285">
                  Username <span className="text-red-500" data-id="element-3286">*</span>
                </label>
                <input type="text" required value={formData.username} onChange={e => setFormData({
                ...formData,
                username: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="username" data-id="element-3287" />
              </div>
              <div className="space-y-1" data-id="element-3288">
                <label className="text-sm font-medium text-gray-700" data-id="element-3289">
                  Email <span className="text-red-500" data-id="element-3290">*</span>
                </label>
                <input type="email" required value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="email@bin.go.id" data-id="element-3291" />
              </div>
            </div>
            <div className="space-y-1" data-id="element-3292">
              <label className="text-sm font-medium text-gray-700" data-id="element-3293">
                Peran <span className="text-red-500" data-id="element-3294">*</span>
              </label>
              <select value={formData.role} onChange={e => setFormData({
              ...formData,
              role: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-3295">
                <option value="Super Admin" data-id="element-3296">Super Admin</option>
                <option value="Admin Deputi" data-id="element-3297">Admin Deputi</option>
                <option value="Admin STIN" data-id="element-3298">Admin STIN</option>
                <option value="Admin BINDA" data-id="element-3299">Admin BINDA</option>
                <option value="User" data-id="element-3300">User</option>
                <option value="Auditor" data-id="element-3301">Auditor</option>
              </select>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-3302">
              <div className="space-y-1" data-id="element-3303">
                <label className="text-sm font-medium text-gray-700" data-id="element-3304">
                  Unit Kerja <span className="text-red-500" data-id="element-3305">*</span>
                </label>
                <input type="text" required value={formData.unit} onChange={e => setFormData({
                ...formData,
                unit: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Contoh: Setuma" data-id="element-3306" />
              </div>
              <div className="space-y-1" data-id="element-3307">
                <label className="text-sm font-medium text-gray-700" data-id="element-3308">
                  Status <span className="text-red-500" data-id="element-3309">*</span>
                </label>
                <select value={formData.status} onChange={e => setFormData({
                ...formData,
                status: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-3310">
                  <option value="Aktif" data-id="element-3311">Aktif</option>
                  <option value="Nonaktif" data-id="element-3312">Nonaktif</option>
                  <option value="Cuti" data-id="element-3313">Cuti</option>
                </select>
              </div>
            </div>
          </form>
        </div>
        <div className="p-4 border-t border-gray-200 flex justify-end space-x-2 bg-gray-50" data-id="element-3314">
          <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-100" data-id="element-3315">
            Batal
          </button>
          <button type="submit" form="user-form" className="px-4 py-2 bg-primary text-secondary rounded-md text-sm font-medium hover:bg-opacity-90" data-id="element-3316">
            Simpan
          </button>
        </div>
      </div>
    </div>;
};
export const UserManagement: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notification, setNotification] = useState({
    show: false,
    message: ''
  });
  const [editingUser, setEditingUser] = useState<any>(null);
  const handleAddUser = () => {
    setEditingUser(null);
    setIsModalOpen(true);
  };
  const handleEditUser = (user: any) => {
    setEditingUser(user);
    setIsModalOpen(true);
  };
  const handleSubmit = (data: any) => {
    setIsModalOpen(false);
    setNotification({
      show: true,
      message: `Pengguna ${data.name} berhasil disimpan`
    });
  };
  const handleActivityLog = () => {
    setNotification({
      show: true,
      message: 'Log aktivitas berhasil dimuat'
    });
  };
  const handleBlockUser = (name: string) => {
    if (window.confirm(`Apakah Anda yakin ingin memblokir pengguna ${name}?`)) {
      setNotification({
        show: true,
        message: `Pengguna ${name} berhasil diblokir`
      });
    }
  };
  // Sample user data for edit functionality
  const users = [{
    name: 'Ahmad Supriyadi',
    username: 'asupriyadi',
    email: 'a.supriyadi@bin.go.id',
    role: 'Super Admin',
    unit: 'Setuma',
    status: 'Aktif'
  }, {
    name: 'Dewi Puspita',
    username: 'dpuspita',
    email: 'd.puspita@bin.go.id',
    role: 'Admin Deputi',
    unit: 'Deputi II',
    status: 'Aktif'
  }, {
    name: 'Budi Santoso',
    username: 'bsantoso',
    email: 'b.santoso@bin.go.id',
    role: 'Admin STIN',
    unit: 'STIN',
    status: 'Aktif'
  }, {
    name: 'Rini Agustina',
    username: 'ragustina',
    email: 'r.agustina@bin.go.id',
    role: 'Admin BINDA',
    unit: 'BINDA Jatim',
    status: 'Cuti'
  }, {
    name: 'Hendra Wijaya',
    username: 'hwijaya',
    email: 'h.wijaya@bin.go.id',
    role: 'Auditor',
    unit: 'Itjen',
    status: 'Aktif'
  }];
  return <div className="space-y-4" data-id="element-3317">
      <div className="flex items-center justify-between mb-4" data-id="element-3318">
        <h1 className="text-2xl font-bold text-secondary flex items-center" data-id="element-3319">
          <UsersIcon size={24} className="mr-2" data-id="element-3320" />
          Manajemen Pengguna
        </h1>
        <div className="flex space-x-2" data-id="element-3321">
          <button onClick={handleActivityLog} className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90" data-id="element-3322">
            Log Aktivitas
          </button>
          <button onClick={handleAddUser} className="bg-primary text-secondary px-4 py-2 rounded-md hover:bg-opacity-90 font-medium" data-id="element-3323">
            + Tambah Pengguna
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-id="element-3324">
        <div className="lg:col-span-2 bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-3325">
          <div className="p-4 border-b border-gray-200 flex flex-wrap gap-3 items-center justify-between" data-id="element-3326">
            <div className="relative flex-grow max-w-md" data-id="element-3327">
              <input type="text" placeholder="Cari pengguna..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-3328" />
              <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-3329" />
            </div>
            <div className="flex items-center gap-2" data-id="element-3330">
              <button className="flex items-center px-3 py-2 bg-gray-100 rounded-md hover:bg-gray-200" data-id="element-3331">
                <FilterIcon size={16} className="mr-1" data-id="element-3332" />
                Filter
              </button>
              <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-3333">
                <option value="" data-id="element-3334">Peran</option>
                <option value="admin" data-id="element-3335">Super Admin</option>
                <option value="deputy" data-id="element-3336">Admin Deputi</option>
                <option value="stin" data-id="element-3337">Admin STIN</option>
                <option value="binda" data-id="element-3338">Admin BINDA</option>
                <option value="user" data-id="element-3339">User</option>
                <option value="auditor" data-id="element-3340">Auditor</option>
              </select>
            </div>
          </div>
          <div className="overflow-x-auto" data-id="element-3341">
            <table className="w-full" data-id="element-3342">
              <thead className="bg-neutral-light" data-id="element-3343">
                <tr data-id="element-3344">
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-3345">
                    Nama
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-3346">
                    Username
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-3347">
                    Email
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-3348">
                    Peran
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-3349">
                    Unit
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-3350">
                    Status
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-3351">
                    Login Terakhir
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-3352">
                    Aksi
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-3353">
                <tr className="hover:bg-neutral-light" data-id="element-3354">
                  <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-3355">
                    <div className="flex items-center" data-id="element-3356">
                      <div className="w-8 h-8 bg-secondary text-white rounded-full flex items-center justify-center mr-2" data-id="element-3357">
                        AS
                      </div>
                      <span data-id="element-3358">Ahmad Supriyadi</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3359">
                    asupriyadi
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3360">
                    a.supriyadi@bin.go.id
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-3361">
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-primary bg-opacity-20 text-secondary" data-id="element-3362">
                      Super Admin
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3363">Setuma</td>
                  <td className="px-4 py-3 text-sm" data-id="element-3364">
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-3365">
                      Aktif
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3366">
                    2023-08-10 08:45
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-3367">
                    <button onClick={() => handleEditUser(users[0])} className="text-accent-info hover:underline" data-id="element-3368">
                      Edit
                    </button>
                  </td>
                </tr>
                <tr className="hover:bg-neutral-light" data-id="element-3369">
                  <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-3370">
                    <div className="flex items-center" data-id="element-3371">
                      <div className="w-8 h-8 bg-secondary text-white rounded-full flex items-center justify-center mr-2" data-id="element-3372">
                        DP
                      </div>
                      <span data-id="element-3373">Dewi Puspita</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3374">dpuspita</td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3375">
                    d.puspita@bin.go.id
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-3376">
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-3377">
                      Admin Deputi
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3378">Deputi II</td>
                  <td className="px-4 py-3 text-sm" data-id="element-3379">
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-3380">
                      Aktif
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3381">
                    2023-08-09 14:22
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-3382">
                    <button onClick={() => handleEditUser(users[1])} className="text-accent-info hover:underline" data-id="element-3383">
                      Edit
                    </button>
                  </td>
                </tr>
                <tr className="hover:bg-neutral-light" data-id="element-3384">
                  <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-3385">
                    <div className="flex items-center" data-id="element-3386">
                      <div className="w-8 h-8 bg-secondary text-white rounded-full flex items-center justify-center mr-2" data-id="element-3387">
                        BS
                      </div>
                      <span data-id="element-3388">Budi Santoso</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3389">bsantoso</td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3390">
                    b.santoso@bin.go.id
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-3391">
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800" data-id="element-3392">
                      Admin STIN
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3393">STIN</td>
                  <td className="px-4 py-3 text-sm" data-id="element-3394">
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-3395">
                      Aktif
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3396">
                    2023-08-10 10:15
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-3397">
                    <button onClick={() => handleEditUser(users[2])} className="text-accent-info hover:underline" data-id="element-3398">
                      Edit
                    </button>
                  </td>
                </tr>
                <tr className="hover:bg-neutral-light" data-id="element-3399">
                  <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-3400">
                    <div className="flex items-center" data-id="element-3401">
                      <div className="w-8 h-8 bg-secondary text-white rounded-full flex items-center justify-center mr-2" data-id="element-3402">
                        RA
                      </div>
                      <span data-id="element-3403">Rini Agustina</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3404">ragustina</td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3405">
                    r.agustina@bin.go.id
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-3406">
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-3407">
                      Admin BINDA
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3408">
                    BINDA Jatim
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-3409">
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-3410">
                      Cuti
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3411">
                    2023-08-01 09:30
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-3412">
                    <button onClick={() => handleEditUser(users[3])} className="text-accent-info hover:underline" data-id="element-3413">
                      Edit
                    </button>
                  </td>
                </tr>
                <tr className="hover:bg-neutral-light" data-id="element-3414">
                  <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-3415">
                    <div className="flex items-center" data-id="element-3416">
                      <div className="w-8 h-8 bg-secondary text-white rounded-full flex items-center justify-center mr-2" data-id="element-3417">
                        HW
                      </div>
                      <span data-id="element-3418">Hendra Wijaya</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3419">hwijaya</td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3420">
                    h.wijaya@bin.go.id
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-3421">
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800" data-id="element-3422">
                      Auditor
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3423">Itjen</td>
                  <td className="px-4 py-3 text-sm" data-id="element-3424">
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-3425">
                      Aktif
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-3426">
                    2023-08-09 16:05
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-3427">
                    <button onClick={() => handleEditUser(users[4])} className="text-accent-info hover:underline" data-id="element-3428">
                      Edit
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="px-4 py-3 border-t border-gray-200 flex items-center justify-between" data-id="element-3429">
            <div className="text-sm text-gray-700" data-id="element-3430">
              Menampilkan 5 dari 124 pengguna
            </div>
            <div className="flex items-center space-x-2" data-id="element-3431">
              <button className="px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50" data-id="element-3432">
                Sebelumnya
              </button>
              <button className="px-3 py-1 bg-secondary text-white rounded-md text-sm" data-id="element-3433">
                1
              </button>
              <button className="px-3 py-1 border border-gray-300 rounded-md text-sm" data-id="element-3434">
                2
              </button>
              <button className="px-3 py-1 border border-gray-300 rounded-md text-sm" data-id="element-3435">
                3
              </button>
              <button className="px-3 py-1 border border-gray-300 rounded-md text-sm" data-id="element-3436">
                Berikutnya
              </button>
            </div>
          </div>
        </div>
        <div className="space-y-4" data-id="element-3437">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-3438">
            <div className="p-3 border-b border-gray-200 bg-neutral-light flex items-center" data-id="element-3439">
              <ShieldIcon size={18} className="mr-2 text-secondary" data-id="element-3440" />
              <h2 className="font-bold text-secondary" data-id="element-3441">Peran & Hak Akses</h2>
            </div>
            <div className="p-4" data-id="element-3442">
              <div className="space-y-3" data-id="element-3443">
                <div className="border border-gray-200 p-3 rounded-lg" data-id="element-3444">
                  <h3 className="font-medium text-secondary mb-1" data-id="element-3445">
                    Super Admin (Setuma)
                  </h3>
                  <p className="text-xs text-gray-600 mb-2" data-id="element-3446">
                    Akses penuh ke seluruh sistem dan data nasional
                  </p>
                  <div className="space-y-1" data-id="element-3447">
                    <div className="flex items-center" data-id="element-3448">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-3449"></span>
                      <span className="text-xs" data-id="element-3450">
                        Manajemen pengguna & peran
                      </span>
                    </div>
                    <div className="flex items-center" data-id="element-3451">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-3452"></span>
                      <span className="text-xs" data-id="element-3453">Audit & log sistem</span>
                    </div>
                    <div className="flex items-center" data-id="element-3454">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-3455"></span>
                      <span className="text-xs" data-id="element-3456">Konfigurasi sistem</span>
                    </div>
                  </div>
                </div>
                <div className="border border-gray-200 p-3 rounded-lg" data-id="element-3457">
                  <h3 className="font-medium text-secondary mb-1" data-id="element-3458">
                    Admin Deputi
                  </h3>
                  <p className="text-xs text-gray-600 mb-2" data-id="element-3459">
                    Kelola & validasi aset sesuai bidang deputi
                  </p>
                  <div className="space-y-1" data-id="element-3460">
                    <div className="flex items-center" data-id="element-3461">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-3462"></span>
                      <span className="text-xs" data-id="element-3463">Manajemen aset deputi</span>
                    </div>
                    <div className="flex items-center" data-id="element-3464">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-3465"></span>
                      <span className="text-xs" data-id="element-3466">Validasi data</span>
                    </div>
                    <div className="flex items-center" data-id="element-3467">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-3468"></span>
                      <span className="text-xs" data-id="element-3469">Laporan deputi</span>
                    </div>
                  </div>
                </div>
                <div className="border border-gray-200 p-3 rounded-lg" data-id="element-3470">
                  <h3 className="font-medium text-secondary mb-1" data-id="element-3471">
                    Admin STIN
                  </h3>
                  <p className="text-xs text-gray-600 mb-2" data-id="element-3472">
                    Kelola aset STIN sebagai entitas nasional mandiri
                  </p>
                  <div className="space-y-1" data-id="element-3473">
                    <div className="flex items-center" data-id="element-3474">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-3475"></span>
                      <span className="text-xs" data-id="element-3476">Manajemen aset STIN</span>
                    </div>
                    <div className="flex items-center" data-id="element-3477">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-3478"></span>
                      <span className="text-xs" data-id="element-3479">Laporan STIN</span>
                    </div>
                    <div className="flex items-center" data-id="element-3480">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-3481"></span>
                      <span className="text-xs" data-id="element-3482">Pemeliharaan & RKA</span>
                    </div>
                  </div>
                </div>
                <div className="border border-gray-200 p-3 rounded-lg" data-id="element-3483">
                  <h3 className="font-medium text-secondary mb-1" data-id="element-3484">
                    Admin BINDA
                  </h3>
                  <p className="text-xs text-gray-600 mb-2" data-id="element-3485">
                    Kelola aset BINDA di tingkat provinsi
                  </p>
                  <div className="space-y-1" data-id="element-3486">
                    <div className="flex items-center" data-id="element-3487">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-3488"></span>
                      <span className="text-xs" data-id="element-3489">Manajemen aset BINDA</span>
                    </div>
                    <div className="flex items-center" data-id="element-3490">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-3491"></span>
                      <span className="text-xs" data-id="element-3492">Laporan provinsi</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-3493">
            <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-3494">
              <h2 className="font-bold text-secondary" data-id="element-3495">
                Session Map & Activity
              </h2>
            </div>
            <div className="p-4" data-id="element-3496">
              <div className="h-48 bg-neutral-light rounded-lg mb-3 p-3 relative" data-id="element-3497">
                {/* Simplified Indonesia map */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3/4 h-1/2 border-2 border-secondary rounded-sm opacity-20" data-id="element-3498"></div>
                {/* Active sessions */}
                <div className="absolute top-1/4 left-1/4 w-3 h-3 bg-accent-green rounded-full animate-pulse" data-id="element-3499"></div>
                <div className="absolute top-1/3 right-1/3 w-3 h-3 bg-accent-green rounded-full animate-pulse" data-id="element-3500"></div>
                <div className="absolute bottom-1/3 left-1/2 w-3 h-3 bg-accent-green rounded-full animate-pulse" data-id="element-3501"></div>
                <div className="absolute top-1/2 right-1/4 w-3 h-3 bg-accent-green rounded-full animate-pulse" data-id="element-3502"></div>
                <div className="absolute bottom-1/4 left-1/3 w-3 h-3 bg-accent-red rounded-full animate-pulse" data-id="element-3503"></div>
              </div>
              <div className="space-y-2" data-id="element-3504">
                <div className="text-xs font-medium text-secondary mb-1" data-id="element-3505">
                  Sesi Aktif (24)
                </div>
                <div className="flex justify-between text-xs" data-id="element-3506">
                  <span className="flex items-center" data-id="element-3507">
                    <span className="w-2 h-2 bg-accent-green rounded-full mr-1" data-id="element-3508"></span>
                    <span data-id="element-3509">Normal (23)</span>
                  </span>
                  <span className="flex items-center" data-id="element-3510">
                    <span className="w-2 h-2 bg-accent-red rounded-full mr-1" data-id="element-3511"></span>
                    <span data-id="element-3512">Anomali (1)</span>
                  </span>
                </div>
                <div className="bg-red-50 border border-red-200 p-2 rounded-md" data-id="element-3513">
                  <div className="flex justify-between items-start" data-id="element-3514">
                    <div data-id="element-3515">
                      <p className="text-xs font-medium text-secondary" data-id="element-3516">
                        Anomali Terdeteksi
                      </p>
                      <p className="text-xs text-gray-700" data-id="element-3517">
                        User: hwijaya | IP: 103.xx.xx.45
                      </p>
                      <p className="text-xs text-gray-700" data-id="element-3518">
                        Lokasi: Bandung (tidak biasa)
                      </p>
                    </div>
                    <button onClick={() => handleBlockUser('hwijaya')} className="bg-accent-red text-white px-2 py-0.5 rounded text-xs hover:bg-opacity-90" data-id="element-3519">
                      Blokir
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <UserFormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSubmit={handleSubmit} initialData={editingUser} data-id="element-3520" />

      <SuccessNotification message={notification.message} isVisible={notification.show} onClose={() => setNotification({
      ...notification,
      show: false
    })} data-id="element-3521" />
    </div>;
};